module.exports = __webpack_public_path__ + "static/media/YM43_3.9f23f8ad.jpg";